import React from 'react';
import { useNavigate } from 'react-router-dom';
import ethLogo from '../assets/eth.svg';
//import baseLogo from '../assets/base.png';

const chains = [
  { name: 'ethereum', image: ethLogo },
];

function getChainFromUrl() {
  const path = window.location.pathname;
  const segments = path.split("/").filter(Boolean);
  const firstSegment = segments[0];
  if (chains.some(c => c.name === firstSegment)) {
    return firstSegment;
  }
  return null;
}

function ChainSelector() {
  const navigate = useNavigate();
  const currentChain = getChainFromUrl() || 'ethereum';

  const handleSelect = (newChain) => {
    if (newChain !== currentChain) {
      navigate(`/${newChain}`);
    }
  };

  return (
    <div className="flex items-center gap-2">
      {chains.map((c) => (
        <button
          key={c.name}
          onClick={() => handleSelect(c.name)}
          className={`flex items-center gap-2 px-3 py-[6px] rounded-full border border-transparent transition-all duration-200 
            ${currentChain === c.name
              ? 'bg-gradient-to-r from-[#b6b6b6a6] to-[#c4c4c4b5] text-black shadow-[0_0_10px_rgba(255,200,150,0.4)]'
              : 'bg-white/10 hover:bg-white/10 hover:text-white/80 hover:border-white/40 text-white'
            }`}
        >
          <img src={c.image} alt={c.name} className="h-4 w-4" />
         
        </button>
      ))}
    </div>
  );
}

function ChainDropdown() {
  return (
    <li className="justify-end gap-4 items-center flex">
      <ChainSelector />
    </li>
  );
}

export default ChainDropdown;
